import React, { useEffect, useState } from 'react';
import Tab from '../components/tab';
import {
  currentEducation,
  dispatchEducation,
  saveEducation,
  personal_information
} from "../../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import { saveIntoServerCache } from '../../../utils/saveIntoCache';
import { convertEducation } from '../../../Redux/convertResume';

export default function Education6({ nextStep, prevStep, setStep }) {
  const dispatch = useDispatch();
  const secret = useSelector(prev => prev.secret);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const info = useSelector((info) => info.personal_info);

  const educ = useSelector(edu => edu.education);
  const [hasExperience, setHasExperience] = useState(null);
  const flowLanguage = useSelector(e => e.t_lang.selected);

  useEffect(() => {
    console.log("Eduaction deleted successfully.")
  }, [educ]);

  let removeEducation = (index) => {
    let allEduaction = educ.education;
    let newExp = allEduaction.filter(element => allEduaction.indexOf(element) !== index);
    dispatch(dispatchEducation(newExp));
  }

  let handleEditEducation = (index) => {
    let allEduaction = educ.education;
    dispatch(currentEducation(allEduaction[index]));
    removeEducation(index);
    setStep(18);
  }

  let handleNext = () => {
    dispatch(convertEducation({ Education: educ.education, Lang: [{lang: flowLanguage }] }, "resume" ))
    let data = { ...info.message, educationReviewed: true }
    dispatch(personal_information(data));
    nextStep();
  }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center w-[100vw]">
      <div>
        <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md py-10 px-6 md:px-8 md:py-8`}>

          <div className='flex justify-center w-full'>
            <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
              <div className="vsm:hidden md:inline">
                <Tab
                  label="Personal Information"
                  current={false}
                  completed={true}
                  num="1"
                />
              </div>
              <div className="vsm:hidden md:inline">
                <Tab num="2" current={false} label="Experience" completed={true} />
              </div>
              <div className="vsm:hidden md:inline">
                <Tab num="3" current={false} label="Skills" completed={true} />
              </div>
              <Tab num="3" current={false} label="Language" completed={true} />
              <Tab num="4" current={true} label="Education" completed={false} />
              <Tab num="5" current={false} label="Professional Summary" completed={false} />
            </div>
          </div>

          <div className='flex justify-center w-full'>
            <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
              <p className="text-center text-black font-semibold notranslate" key={flowLanguage}>
                {flowLanguage == "Spanish" ? (
                  "¡Genial! ¿Continuamos?"
                ) : (
                  "That is great, Let's Move on?"
                )}
                
              </p>
            </div>
          </div>

          <div className='flex justify-center w-full'>
            <div className="flex justify-between lg:max-w-[90%] w-full">
              <button
                onClick={prevStep}
                className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 vsm:px-4 px-8 rounded-md">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 8.99891L9.5 16.3789" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.5 9L9.5 1.62" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "ANTERIOR"
                  ) : (
                    "PREVIOUS"
                  )}
                </span> 
              </button>
              <button
                onClick={handleNext}
                className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4 px-6 rounded-md" >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "GUARDAR"
                  ) : (
                    "SAVE"
                  )}
                </span>
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 8.99891L1.5 16.3789" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.5 9L1.5 1.62" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>

        </div>

        <div className='w-full max-w-[1000px] flex justify-center mt-10'>
          <div className='flex flex-col gap-y-6 w-full lg:max-w-[90%]'>
            <p className="text-black font-semibold notranslate" key={flowLanguage}>
              {flowLanguage == "Spanish" ? (
                "Has agregado las siguientes formaciones académicas. Puedes editarlas más tarde."
              ) : (
                "You have added the eduaction(s) below. You can edit it later."
              )}            
            </p>
            {
              educ.education !== null && educ.education?.length > 0 && (
                <>{educ.education?.map((element, index) => (
                  <div className='relative w-full flex p-6 flex-col border border-[#FF6633] gap-2 rounded-md'  key={index}>
                    <div onClick={() => handleEditEducation(index)}>
                      <p className='text-2xl font-semibold notranslate'>{element?.School}</p>
                      <p className='text-base font-medium'>{element?.course}</p>
                      <p className='text-base font-medium'>{element?.Degree}</p>
                      <p className='text-base font-medium'>{element?.End_date}</p>
                    </div>
                    <div className='absolute right-[-5px] top-[-7px]' onClick={() => removeEducation(index)}>
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1.22266" y="0.5" width="24.2767" height="24.2767" rx="12.1383" fill="white" />
                        <rect x="1.22266" y="0.5" width="24.2767" height="24.2767" rx="12.1383" stroke="#FF6633" />
                        <path d="M16.3146 18.1785C16.2385 18.1785 16.1665 18.1438 16.119 18.0842L13.4289 14.7068C13.3258 14.5774 13.1276 14.582 13.0307 14.7161L10.6034 18.0749C10.5564 18.14 10.481 18.1785 10.4008 18.1785H7.93029C7.72247 18.1785 7.60538 17.9397 7.73266 17.7754L11.6277 12.7479C11.6984 12.6567 11.6975 12.5289 11.6254 12.4387L7.68574 7.50761C7.55494 7.34389 7.6715 7.10156 7.88106 7.10156H10.4084C10.4843 7.10156 10.5562 7.13609 10.6036 7.1954L13.2934 10.558C13.3967 10.6871 13.5948 10.6821 13.6915 10.5479L16.0996 7.20542C16.1466 7.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L19.0381 17.7727C19.1685 17.9365 19.0519 18.1785 18.8425 18.1785H16.3146Z" fill="#FF6633" />
                      </svg>
                    </div>
                  </div>
                ))}</>
              )
            }

          </div>
        </div>
      </div>
    </div>
  );
}